import { jsx } from "react/jsx-runtime";
import { Button } from "antd";
import classnames from "classnames";
import { rootClass } from "./constant.js";
import use_button_color from "./hooks/use-button-color.js";
import "./index.css";
import { useMemo } from "react";
function Button_Button(props) {
    const { type: _, color: __, size = 'middle', ...rest } = props;
    const { buttonColorProps } = use_button_color(props);
    const minWidthClassName = useMemo(()=>{
        if (props.children) return 'minWidth';
        return '';
    }, [
        props.children
    ]);
    return /*#__PURE__*/ jsx(Button, {
        ...rest,
        ...buttonColorProps,
        autoInsertSpace: false,
        size: size,
        className: classnames(rootClass, props.className, buttonColorProps.className, size, minWidthClassName, buttonColorProps.type)
    });
}
const button_Button = Button_Button;
export { button_Button as default };
